import { Capacitor } from '@capacitor/core';
import { CANONICAL_ALIAS, PUBLIC_PAGES } from '@/components/SiteMetadata';

export const ANALYTICS_CHOICE_KEY = 'ca:analytics-consent:v1';
// Existing public measurement identifier; never creates a property or a credential.
export const GA_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID || 'G-D9ED8D4DLH';
export const VALID_GA_ID = GA_ID === 'G-D9ED8D4DLH';
const ORIGIN = 'https://www.cainversionesservicios.com';
const EVENTS = new Set(['generate_lead', 'click_phone', 'click_whatsapp']);
let lastPageLocation = null;

export function isPublicAnalyticsPage(pathname = window.location.pathname) {
  return Boolean(PUBLIC_PAGES[CANONICAL_ALIAS[pathname] || pathname]);
}
function hasConsent() {
  try { return window.localStorage.getItem(ANALYTICS_CHOICE_KEY) === 'yes'; }
  catch { return false; }
}
function allowed(pathname) {
  return VALID_GA_ID && !Capacitor.isNativePlatform() &&
    window.location.origin === ORIGIN && isPublicAnalyticsPage(pathname) && hasConsent();
}
function pageFields(pathname) {
  const canonical = CANONICAL_ALIAS[pathname] || pathname;
  return { page_location: `${ORIGIN}${canonical}`, page_referrer: `${ORIGIN}/`, page_title: PUBLIC_PAGES[canonical][0] };
}
// Before publication, disable enhanced measurement in the existing GA4 stream:
// automatic form, link and history events are not constrained by this allowlist.
export function syncPublicAnalytics(choice, pathname) {
  const enabled = choice === 'yes' && allowed(pathname);
  window[`ga-disable-${GA_ID}`] = !enabled;
  if (!enabled) {
    lastPageLocation = null;
    window.gtag?.('consent', 'update', { analytics_storage: 'denied' });
    return;
  }
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() { window.dataLayer.push(arguments); };
  if (!document.getElementById('ca-ga4-script')) {
    window.gtag('consent', 'default', { analytics_storage: 'denied', ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied' });
    window.gtag('js', new Date());
    const script = document.createElement('script');
    script.id = 'ca-ga4-script'; script.async = true; script.referrerPolicy = 'no-referrer';
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(script);
  }
  window.gtag('consent', 'update', { analytics_storage: 'granted' });
  const fields = pageFields(pathname);
  window.gtag('config', GA_ID, {
    send_page_view: false, allow_google_signals: false, allow_ad_personalization_signals: false,
    ...fields,
  });
  // Effects can repeat in StrictMode; count an uninterrupted canonical visit once.
  if (lastPageLocation !== fields.page_location) {
    lastPageLocation = fields.page_location;
    window.gtag('event', 'page_view', { send_to: GA_ID, ...fields });
  }
}
// Only fixed names and canonical public context; no event arguments from forms.
export function trackPublicEvent(name) {
  if (!EVENTS.has(name) || !allowed(window.location.pathname)) return;
  if (window[`ga-disable-${GA_ID}`] || !document.getElementById('ca-ga4-script')) return;
  window.gtag?.('event', name, { send_to: GA_ID, ...pageFields(window.location.pathname) });
}

